import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core'
import { MatBadge } from '@angular/material/badge'
import { MatButton } from '@angular/material/button'
import { ThemePalette } from '@angular/material/core'
import { OutputJobIndicatorComponent } from '@elderbyte/ngx-imprimo'
import { PrintCommandDirective } from '../print-command.directive'
import { PrintConfigStateComponent } from '../print-config-state/print-config-state.component'

@Component({
  selector: 'app-print-button',
  templateUrl: './print-button.component.html',
  styleUrls: ['./print-button.component.scss'],
  imports: [MatButton, MatBadge, PrintConfigStateComponent, AsyncPipe, OutputJobIndicatorComponent],
})
export class PrintButtonComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  protected readonly printCommand = inject(PrintCommandDirective)

  @Input()
  public disabled = false

  @Input()
  public color: ThemePalette
}
